var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon404Right(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 516,
    height: 424,
    viewBox: "0 0 516 424",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M29.1584 365.071L21.4879 368.494L57.3545 400.234L54.221 384.649L78.1216 399.359L48.2702 369.928L47.5044 383.459L37.149 372.287L43.7802 366.544L4.04465 339.118L2.60019 338.563L29.1584 365.071Z",
    fill: "#C74AE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M79.175 33.4191L26.8755 49.4331L34.0192 52.4982L8.00042 55.1313L21.0524 49.6438L16.0831 47.8227L60.0612 29.183L57.5137 35.501L79.175 33.4191Z",
    fill: "#C74AE3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110 213.073H516",
    stroke: "#2D112D",
    strokeWidth: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.014 230.503H126.95C129.35 230.503 131.652 229.47 133.349 227.63C135.046 225.791 136 223.297 136 220.696V203.304C136.002 201.885 135.719 200.483 135.17 199.194C134.622 197.905 133.821 196.761 132.824 195.841V195.841C131.187 194.328 129.105 193.498 126.953 193.501H106.017L106.014 230.503Z",
    fill: "#2D112D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M57.2114 249.833H99.0302C100.566 249.833 102.087 249.506 103.506 248.869C104.925 248.231 106.215 247.298 107.301 246.121C108.387 244.944 109.248 243.546 109.835 242.009C110.423 240.471 110.725 238.823 110.725 237.158L110.725 186.849C110.725 185.184 110.422 183.537 109.834 181.999C109.247 180.462 108.385 179.065 107.299 177.888C106.214 176.711 104.924 175.778 103.505 175.141C102.087 174.504 100.566 174.177 99.0302 174.177H57.2114L57.2114 249.833Z",
    fill: "#735F73"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48 169.663L48 254.337C48 255.255 48.6872 256 49.5348 256H55.6739C56.5215 256 57.2085 255.255 57.2085 254.337L57.2085 169.663C57.2085 168.744 56.5215 168 55.6739 168H49.5348C48.6872 168 48 168.744 48 169.663Z",
    fill: "#4A2F4A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2114 249.833H99.0302C100.566 249.833 102.087 249.506 103.506 248.869C104.925 248.231 106.215 247.298 107.301 246.121C108.387 244.944 109.248 243.546 109.835 242.009C110.423 240.471 110.725 238.823 110.725 237.158L110.725 186.849C110.725 185.184 110.422 183.537 109.834 181.999C109.247 180.462 108.385 179.065 107.299 177.888C106.214 176.711 104.924 175.778 103.505 175.141C102.087 174.504 100.566 174.177 99.0302 174.177C95.548 228.508 57.2114 233.497 57.2114 233.497L57.2114 249.833Z",
    fill: "#4A2F4A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5811 249.833L60.5811 174.17H57.2085L57.2085 249.833H60.5811Z",
    fill: "#2D112D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8995 249.834H99.0429C100.579 249.834 102.1 249.506 103.519 248.869C104.938 248.232 106.227 247.298 107.313 246.121C108.399 244.944 109.261 243.547 109.848 242.009C110.436 240.471 110.738 238.823 110.737 237.159V201.837C110.724 237.504 74.8995 249.834 74.8995 249.834Z",
    fill: "#2D112D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M112.908 230.499V193.497H110.722V230.499H112.908Z",
    fill: "#2D112D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M110.725 230.503H126.95C129.35 230.503 131.652 229.469 133.349 227.63C135.046 225.791 136 223.297 136 220.696V203.304C136.002 201.885 135.719 200.482 135.17 199.194C134.622 197.905 133.821 196.761 132.824 195.841V195.841C135.89 222.949 110.728 227.089 110.728 227.089L110.725 230.503Z",
    fill: "#2D112D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon404Right);
export default __webpack_public_path__ + "static/media/icon-404-right.7fb77f61d2cee04e16f75a60470d3ff1.svg";
export { ForwardRef as ReactComponent };